import { createFileRoute } from "@tanstack/react-router";
import ProspectForm from "@/pages/ProspectForm";

export const Route = createFileRoute("/prospect-form/$coachId")({
  component: ProspectForm,
});
